module.exports = __webpack_public_path__ + "img/square-purple.5eed6509.svg";